import { render, staticRenderFns } from "./details2.vue?vue&type=template&id=aa21fada&scoped=true&"
import script from "./details2.vue?vue&type=script&lang=js&"
export * from "./details2.vue?vue&type=script&lang=js&"
import style0 from "./details2.vue?vue&type=style&index=0&id=aa21fada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa21fada",
  null
  
)

component.options.__file = "details2.vue"
export default component.exports